import { SUPPORT_EMAIL } from 'src/constants/Developer';
import {
  MANUAL_DNS_VERIFY_EMAIL_BODY,
  MANUAL_DNS_VERIFY_EMAIL_SUBJECT,
} from 'src/constants/notification';

export const getManualDnsVerifyEmailLink = (userMail: string) => {
  const encodedSubject = encodeURIComponent(MANUAL_DNS_VERIFY_EMAIL_SUBJECT);
  const encodedBody = encodeURIComponent(MANUAL_DNS_VERIFY_EMAIL_BODY);

  return `https://mail.google.com/mail/u/${userMail}/?view=cm&fs=1&tf=1&to=${SUPPORT_EMAIL}&su=${encodedSubject}&body=${encodedBody}`;
};
